var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65905",
    "data-name": "Group 65905",
    transform: "translate(15248 -8107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16419",
    "data-name": "Rectangle 16419",
    width: 25,
    height: 25,
    transform: "translate(-15248 8107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "undo-right-round-svgrepo-com",
    d: "M19.251,3.516a.908.908,0,0,1,1.284,0l3.631,3.631a.908.908,0,0,1,0,1.284l-3.631,3.631a.908.908,0,0,1-1.284-1.284L21.332,8.7H10.21a5.144,5.144,0,1,0,0,10.288h8.473a.908.908,0,1,1,0,1.816H10.21a6.96,6.96,0,1,1,0-13.919H21.332L19.251,4.8A.908.908,0,0,1,19.251,3.516Z",
    transform: "translate(-15249.25 8107.75)",
    fill: "#102633",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoIcon);
export default __webpack_public_path__ + "static/media/redoIcon.335d32b3074c7c6ea3dd3cce4444ac6c.svg";
export { ForwardRef as ReactComponent };